import { inject, Injectable } from "@angular/core";
import { FUSE_APP_CONFIG } from "@fuse/services/config/config.constants";
import { environment } from "environments/environment";
import { merge } from "lodash-es";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class FuseConfigService {
  private readonly _config = new BehaviorSubject(inject(FUSE_APP_CONFIG));

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Setter & getter for config
   */
  set config(value: any) {
    // Merge the new config over to the current config
    const config = merge({}, this._config.getValue(), value);
    window.localStorage.setItem(
      `fuse-config-${environment.appTitle}`,
      JSON.stringify(config),
    );

    // Execute the observable
    this._config.next(config);
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  get config$(): Observable<any> {
    return this._config.asObservable();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Resets the config to the default
   */
  reset(): void {
    // Set the config
    this._config.next(this.config);
    window.localStorage.removeItem(`fuse-config-${environment.appTitle}`);
  }
}
